import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { toast } from 'sonner';
import { IPhoneCall } from '../../../../extViewmodels';
import { getDisplayName } from '../../../../models/NameUtils';
import { copyToClipboard } from '../../../../models/UiUtils';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { Button } from '../../../../web/components-v2/Button';
import { DuplicateIcon } from '../../../../web/components/svgs/icons/DuplicateIcon';
import { PlayIcon } from '../../../../web/components/svgs/icons/PlayIcon';
import { useAudio } from '../../../contexts/audioPlayer';
import { styleSheet } from './styles';

interface IProps {
	phoneCall?: IPhoneCall;
	variant: 'row' | 'card';
}

export const RecordingActions: React.FC<IProps> = ({ phoneCall, variant }) => {
	const audio = useAudio();
	const userSession = useUserSession();

	if (!phoneCall?.recording?.publicUrl) {
		return variant === 'row' ? <span className={css(styleSheet.muted)}>None</span> : null;
	}

	const onPlay = () => {
		audio.setIsOpen(true)();
		audio.setAudioSrc(phoneCall.recording.publicUrl);
		audio.setTitle(`Call Recording (${moment(phoneCall.creationDate).format('M/DD/YYYY [at] h:mma')})`);
		audio.setSubtitle(`${getDisplayName(phoneCall.creator)} called ${phoneCall.phoneNumber?.standard}`);
		audio.setPhoneCallId(phoneCall.id);
		audio.setSurface(variant === 'row' ? 'leadViewRow' : 'cardView');
	};

	if (variant === 'card') {
		return (
			<Button type='button' variant='link' size='sm' onClick={onPlay}>
				Play recording
			</Button>
		);
	}

	const onCopyLink = () => {
		const url = `${userSession.webServiceHelper.baseUrl}/PhoneCall/${phoneCall.id}/Download`;
		if (copyToClipboard(url)) {
			toast.success('Link copied to clipboard');
		} else {
			toast.error('Link failed to copy to clipboard');
		}
	};

	return (
		<div className={css(styleSheet.recording)}>
			<Button type='button' variant='primary' size='sm' onClick={onPlay}>
				<PlayIcon width={16} height={16} />
				Play
			</Button>
			{userSession.account?.features?.aida?.allowAnonymousAccessToCallRecording ? (
				<Button type='button' variant='ghost' size='icon' aria-label='Copy recording link' onClick={onCopyLink}>
					<DuplicateIcon fillColor='currentColor' />
				</Button>
			) : null}
		</div>
	);
};
